import { StylePropertyDefinition } from '../../types/common';

export const styleProperties: Array<StylePropertyDefinition> = [
	{
		dn: 'Markdown TOC Font',
		n: 'markdownTOCFont',
		dv: '<primaryFont>',
		cp: 'font',
		sel: ' ',
	},

	{
		gn: 'MarkdownTOC Margin Left',
		dn: 'MarkdownTOC Margin Left H1',
		n: 'markdowntocmarginleftH1',
		dv: '5px',
		cp: 'margin-left',
		sel: 'a._heading1',
	},
	{
		gn: 'MarkdownTOC Margin Left',
		dn: 'MarkdownTOC Margin Left H2',
		n: 'markdowntocmarginleftH2',
		dv: '10px',
		cp: 'margin-left',
		sel: 'a._heading2',
	},
	{
		gn: 'MarkdownTOC Margin Left',
		dn: 'MarkdownTOC Margin Left H3',
		n: 'markdowntocmarginleftH3',
		dv: '15px',
		cp: 'margin-left',
		sel: 'a._heading3',
	},
	{
		gn: 'MarkdownTOC Margin Left',
		dn: 'MarkdownTOC Margin Left H4',
		n: 'markdowntocmarginleftH4',
		dv: '20px',
		cp: 'margin-left',
		sel: 'a._heading4',
	},
	{
		gn: 'MarkdownTOC Margin Left',
		dn: 'MarkdownTOC Margin Left H5',
		n: 'markdowntocmarginleftH5',
		dv: '25px',
		cp: 'margin-left',
		sel: 'a._heading5',
	},
	{
		gn: 'MarkdownTOC Margin Left',
		dn: 'MarkdownTOC Margin Left H6',
		n: 'markdowntocmarginleftH6',
		dv: '30px',
		cp: 'margin-left',
		sel: 'a._heading6',
	},

	{
		gn: 'MarkdownTOC Text decoration',
		dn: 'MarkdownTOC Text decoration H1',
		n: 'markdowntoctextdecorationH1',
		dv: 'none',
		cp: 'text-decoration',
		sel: 'a._heading1',
	},
	{
		gn: 'MarkdownTOC Text decoration',
		dn: 'MarkdownTOC Text decoration H2',
		n: 'markdowntoctextdecorationH2',
		dv: 'none',
		cp: 'text-decoration',
		sel: 'a._heading2',
	},
	{
		gn: 'MarkdownTOC Text decoration',
		dn: 'MarkdownTOC Text decoration H3',
		n: 'markdowntoctextdecorationH3',
		dv: 'none',
		cp: 'text-decoration',
		sel: 'a._heading3',
	},
	{
		gn: 'MarkdownTOC Text decoration',
		dn: 'MarkdownTOC Text decoration H4',
		n: 'markdowntoctextdecorationH4',
		dv: 'none',
		cp: 'text-decoration',
		sel: 'a._heading4',
	},
	{
		gn: 'MarkdownTOC Text decoration',
		dn: 'MarkdownTOC Text decoration H5',
		n: 'markdowntoctextdecorationH5',
		dv: 'none',
		cp: 'text-decoration',
		sel: 'a._heading5',
	},
	{
		gn: 'MarkdownTOC Text decoration',
		dn: 'MarkdownTOC Text decoration H6',
		n: 'markdowntoctextdecorationH6',
		dv: 'none',
		cp: 'text-decoration',
		sel: 'a._heading6',
	},
	{
		gn: 'MarkdownTOC Text decoration',
		dn: 'MarkdownTOC Text decoration Top Label',
		n: 'markdowntoctextdecorationTopLabel',
		dv: 'none',
		cp: 'text-decoration',
		sel: 'a._topLabel',
	},
	{
		gn: 'MarkdownTOC Text decoration',
		dn: 'MarkdownTOC Text decoration Bottom Label',
		n: 'markdowntoctextdecorationBottomLabel',
		dv: 'none',
		cp: 'text-decoration',
		sel: 'a._bottomLabel',
	},

	{
		gn: 'MarkdownTOC Gap',
		dn: 'MarkdownTOC Gap Container',
		n: 'markdowntocgapContainer',
		dv: '5px',
		cp: 'gap',
		sel: ' ',
	},

	{
		gn: 'MarkdownTOC Inline',
		dn: 'MarkdownTOC Inline Gap',
		n: 'markdowntocinlineGap',
		dv: '5px',
		cp: 'gap',
		sel: 'a',
	},
	{
		gn: 'MarkdownTOC Inline',
		dn: 'MarkdownTOC Inline Align',
		n: 'markdowntocinlineAlign',
		dv: 'center',
		cp: 'align-items',
		sel: 'a',
	},

	{
		gn: 'MarkdownTOC Color',
		dn: 'MarkdownTOC Color Primary',
		n: 'markdowntoccolorprimary',
		dv: '<fontColorThree>',
		cp: 'color',
		sel: '.comp.compMarkdownTOC._primary a',
		np: true,
	},
	{
		gn: 'MarkdownTOC Color',
		dn: 'MarkdownTOC Color Secondary',
		n: 'markdowntoccolorsecondary',
		dv: '<fontColorFour>',
		cp: 'color',
		sel: '.comp.compMarkdownTOC._secondary a',
		np: true,
	},
	{
		gn: 'MarkdownTOC Color',
		dn: 'MarkdownTOC Color Tertiary',
		n: 'markdowntoccolortertiary',
		dv: '<fontColorFive>',
		cp: 'color',
		sel: '.comp.compMarkdownTOC._tertiary a',
		np: true,
	},
	{
		gn: 'MarkdownTOC Color',
		dn: 'MarkdownTOC Color Quaternary',
		n: 'markdowntoccolorquaternary',
		dv: '<fontColorNine>',
		cp: 'color',
		sel: '.comp.compMarkdownTOC._quaternary a',
		np: true,
	},
	{
		gn: 'MarkdownTOC Color',
		dn: 'MarkdownTOC Color Quinary',
		n: 'markdowntoccolorquinary',
		dv: '<fontColorSeven>',
		cp: 'color',
		sel: '.comp.compMarkdownTOC._quinary a',
		np: true,
	},

	{
		gn: 'Collapsible Icon',
		dn: 'Collapsible Icon Width',
		n: 'collapsibleiconWidth',
		dv: '15px',
		cp: 'width',
		sel: 'i._collapsibleIcon ',
	},
];

export const styleDefaults = new Map<string, string>(
	styleProperties
		.filter(e => !!e.dv)
		.map(({ n: name, dv: defaultValue }) => [name, defaultValue!]),
);
